export default {
  name: 'spaces',

  ui: {
    switch: '[js-spaces-switch]',
    interior: '[js-spaces-interior]',
    exterior: '[js-spaces-exterior]',
  },

  events: [
    {
      on: 'change',
      target: 'switch',
      handle () {
        this.ui.interior.classList.toggle('hidden')
        this.ui.exterior.classList.toggle('hidden')
      },
    },
  ],
}
